import React from 'react'
import { useCmsPageByPath } from 'lib/core/hooks'
import { PublicLayout } from 'app/livbrite/components/PublicLayout'
import { Header } from './components/Header'
import { Survey } from './components/Survey'
import { Community } from './components/Community'
import { Lifestyle } from './components/Lifestyle'
import { Inspiration } from './components/Inspiration'
import { MetaData } from 'components/MetaData'

export const Home = () => {
  const { title, meta_description: metaDescription, meta_title: metaTitle } = useCmsPageByPath('home')
  return (
    <PublicLayout className='general-content'>
      <MetaData
        title={title ?? metaTitle}
        description={metaDescription}
      />
      <div>
        <Header />
        <Community />
        <Survey />
        <Lifestyle />
        <Inspiration />
      </div>
    </PublicLayout>
  )
}
